<template>
  <base-section
    id="members"
  >
    <!---
    <base-section-heading title="Program Committee">
    </base-section-heading>
    --->
    <v-container>
      <base-title
        title="Program Committee Members"
        size="text-h4"
        class="text-center"
      />
      <base-section-heading
      divider=null
      >
      The Members of the Program Committee are expert professionals of the scientific testing community. They are requested to return fair opinions and indications on how to improve the scientific papers.
      </base-section-heading>
      <v-row>
        <v-col
          v-for="(member, i) in members"
          :key="i"
          cols="12"
          md="6"
        >
          <base-section
            space="0"
            style="text-align: left"
          >
            {{ member.title }} - <i>{{ member.text }}</i>
          </base-section>
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Members',
    data: () => ({
      isMobile: false,
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      members: [
        {
          title: 'Husasm Amrouch',
          text: 'University of Stuttgart, DE',
        },
        {
          title: 'Lorena Anghel',
          text: 'UGA, FR',
        },
        {
          title: 'Ralf Arnold',
          text: 'Infineon, DE',
        },
        {
          title: 'Manuel Barragan',
          text: 'TIMA Laboratory, FR',
        },
        {
          title: 'Mounir Benabdenbi',
          text: 'TIMA Laboratory, FR',
        },
        {
          title: 'Leticia Bolzani Poehls',
          text: 'RWTH Aachen, DE',
        },
        {
          title: 'Gabriele Boschi',
          text: 'Intel',
        },
        {
          title: 'Ramon Canal',
          text: 'UPC, ES',
        },
        {
          title: 'Luca Cassano',
          text: 'Politecnico di Milano, IT',
        },
        {
          title: 'Sameer Chillarige',
          text: 'Cadence Design Systems',
        },
        {
          title: 'Rolf Drechsler',
          text: 'University of Bremen, DE',
        },
        {
          title: 'William R. Eisenstadt',
          text: 'University of Florida, US',
        },
        {
          title: 'Piet Engelke',
          text: 'Infineon Technologies AG',
        },
        {
          title: 'Petr Fiser',
          text: 'CTU in Prague, CZ',
        },
        {
          title: 'Marie-Lise Flottes',
          text: 'LIRMM, FR',
        },
        {
          title: 'Valentin Gherman',
          text: 'CEA LIST, FR',
        },
        {
          title: 'Benedikt Gierlichs',
          text: 'KU Leuven, BE',
        },
        {
          title: 'Dimitris Gizopoulos',
          text: 'University of Athens, GR',
        },
        {
          title: 'Andreas Glowatz',
          text: 'Siemens EDA',
        },
        {
          title: 'Fey Goerschwin',
          text: 'TU Hamburg, DE',
        },
        {
          title: 'José Luis Gonzalez',
          text: 'CEA LETI, FR',
        },
        {
          title: 'Gurgen Harutyunyan',
          text: 'Synopsys, US',
        },
        {
          title: 'David Hely',
          text: 'University Grenoble Alpes, FR',
        },
        {
          title: 'Stefan Holst',
          text: 'Kyushu Institute of Technology, JP',
        },
        {
          title: 'Jiun-Lang Huang',
          text: 'National Taiwan University',
        },
        {
          title: 'Junlin Huang',
          text: 'HiSilicon',
        },
        {
          title: 'Shi-Yu Huang',
          text: 'NTHU',
        },
        {
          title: 'Sebastian Huhn',
          text: 'University of Bremen, DE',
        },
        {
          title: 'Byul Hur',
          text: 'Texas A&M Engineering, US',
        },
        {
          title: 'Hailong Jiao',
          text: 'Peking University, CN',
        },
        {
          title: 'Artur Jutman',
          text: 'Testonica Lab',
        },
        {
          title: 'Naghmeh Karimi',
          text: 'University of Maryland Baltimore County, US',
        },
        {
          title: 'Ramesh Karri',
          text: 'NYU, US',
        },
        {
          title: 'Elif Bilge Kavun',
          text: 'Passau University, DE',
        },
        {
          title: 'David Keezer',
          text: 'Georgia Tech',
        },
        {
          title: 'Wolfgang Kunz',
          text: 'University of Kaiserslautern, DE',
        },
        {
          title: 'Huawei Li',
          text: 'Chinese Academy of Sciences, CN',
        },
        {
          title: 'Jose Machado Da Silva',
          text: 'University of Porto, PT',
        },
        {
          title: 'Yiorgos Makris',
          text: 'UT Dallas, US',
        },
        {
          title: 'Salvador Manich',
          text: 'UPC, ES',
        },
        {
          title: 'Cédric Marchand',
          text: 'University of Lyon, FR',
        },
        {
          title: 'Grzegorz Mrugalski',
          text: 'Siemens EDA',
        },
        {
          title: 'Maria Mushtaq',
          text: 'Paristech, FR',
        },
        {
          title: 'Nicola Nicolici',
          text: 'McMaster University',
        },
        {
          title: 'Fabio Pavanello',
          text: 'INL/Ecole Centrale Lyon, FR',
        },
        {
          title: 'Mauro Pipponzi',
          text: 'ELES',
        },
        {
          title: 'Mihalis Psarakis',
          text: 'University of Piraeus, GR',
        },
        {
          title: 'Jaan Raik',
          text: 'Tallinn University of Technology, EE',
        },
        {
          title: 'Andrew Richardson',
          text: 'University of Lancaster, UK',
        },
        {
          title: 'Rosa Rodríguez',
          text: 'UPC, ES',
        },
        {
          title: 'Samah Saeed',
          text: 'City University New York, US',
        },
        {
          title: 'Matthias Sauer',
          text: 'Advantest',
        },
        {
          title: 'Mario Schoelzel',
          text: 'University of Applied Science Nordhausen',
        },
        {
          title: 'Christoph Scholl',
          text: 'University of Freiburg, DE',
        },
        {
          title: 'Danil Sokolov',
          text: 'Dialog Semiconductor, UK',
        },
        {
          title: 'Zoran Stamenkovic',
          text: 'IHP',
        },
        {
          title: 'Michele Stucchi',
          text: 'IMEC, BE',
        },
        {
          title: 'Fei SU',
          text: 'Intel, US',
        },
        {
          title: 'Marcello Traiola',
          text: 'INRIA Rennes, FR',
        },
        {
          title: 'Yiorgos Tsiatouhas',
          text: 'University of Ioannina, GR',
        },
        {
          title: 'Emanuele Valea',
          text: 'CEA, FR',
        },
        {
          title: 'Federico Venini',
          text: 'AMD-Xilinx, US',
        },
        {
          title: 'Massimo Violante',
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Xiaoqing Wen',
          text: 'Kyushu Institute of Technology, JP',
        },
        {
          title: 'Robert Wille',
          text: 'TUM, DE',
        },
        {
          title: 'Alberto Yufera',
          text: 'CNM/Universidad de Sevilla, ES',
        },
        {
          title: 'Ying Zhang',
          text: 'Tongi University, CN',
        },
        {
          title: 'Vladimir Zivkovic',
          text: 'Infineon',
        },
        {
          title: 'Luigi Dilillo',
          text: 'LIRMM, FR',
        },
        {
          title: 'Stelios Neophytou',
          text: 'University of Nicosia, CY',
        },
        {
          title: 'Giuseppe Ortolani',
          text: 'STMicroelectronics, IT',
        },
        {
          title: 'Soumya Mittal',
          text: 'Qualcomm Technologies Inc., US',
        },
        {
          title: 'Arjun Chaundhuri',
          text: 'NVIDIA, US',
        },
        {
          title: 'Michele Portolan',
          text: 'TIMA Laboratory, FR',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
